
export const updateUserInChatLogs = (prevState, messageId, updateFn) => {
  const updatedUsers = prevState.users?.map(user => {
    if (user.messageId === messageId) {
      if (typeof updateFn === 'function') {
        return updateFn(user);
      }
      return { ...user, ...updateFn };
    }
    return user;
  }) || [];

  return {
    ...prevState,
    users: updatedUsers
  };
};

export const addMessageToUser = (prevState, messageId, newMessage, userUpdates = {}) => {
  return updateUserInChatLogs(prevState, messageId, (user) => ({
    ...user,
    ...userUpdates,
    messages: {
      ...user.messages,
      response: [...(user.messages?.response || []), newMessage]
    }
  }));
};


export const setUserMessages = (prevState, messageId, newMessages, userUpdates = {}) => {
  return updateUserInChatLogs(prevState, messageId, (user) => ({
    ...user,
    ...userUpdates,
    messages: {
      ...user.messages,
      response: newMessages
    }
  }));
};


export const updateUserFromMessage = (prevState, messageId, messageData) => {
  return updateUserInChatLogs(prevState, messageId, (user) => ({
    ...user,
    lastMessage: messageData.message,
    lastMessageAt: messageData.messageSent,
    unreadCount: messageData.unreadCount,
    messages: {
      ...user.messages,
      response: [...(user.messages?.response || []), messageData]
    }
  }));
};


export const getUserFromChatLogs = (chatLogs, messageId) => {
  return chatLogs?.users?.find(user => user.messageId === messageId);
};


export const getUserMessages = (chatLogs, messageId) => {
  const user = getUserFromChatLogs(chatLogs, messageId);
  return user?.messages?.response || [];
};
